import React from "react";

const WorkflowTypeCell = ({ dataItem, field = "", onRowDoubleClick }) => {
  const dataValue = dataItem[field] === null ? "" : dataItem[field];
  const handleDoubleClick = (event) => {
    if (onRowDoubleClick) {
      onRowDoubleClick({ dataItem });
    }
  };

  return (
    <td onDoubleClick={handleDoubleClick}>
      <p className="gridBoldField m-0">
        {dataValue === 0 || !dataValue
          ? "Folder"
          : dataValue === "UserScreen"
          ? "User Screen"
          : dataValue}{" "}
      </p>
    </td>
  );
};

export default WorkflowTypeCell;
